<app-closeable-dialog-title
  [allowMaximize]="false"
  [title]="data.title">

</app-closeable-dialog-title>

<div mat-dialog-content class="dialog--content">
  <p class="message" [innerHTML]="data.message"></p>
  @if (data.warningMessage) {
    <app-error-card
      [extendingText]="data.warningExtendingText"
      [warningButtonText]="data.warningButtonText"
      (warningClicked)="onWarningClick()"
    >
      <span extendingText [innerHTML]="data.warningMessage"></span>
      <span [innerHTML]="data.warningMessage"></span>
    </app-error-card>
  }
</div>

<div mat-dialog-actions align="end">
  @if (data.dismissButtonText) {
    <button mat-button (click)="onDismiss()">
      {{ data.dismissButtonText }}
    </button>
  }
  <button mat-raised-button class="save-btn" (click)="onConfirm()">
    {{ data.confirmButtonText }}
  </button>
</div>
